import { render, staticRenderFns } from "./loader-invitado.vue?vue&type=template&id=c9f2e93a&scoped=true&"
import script from "./loader-invitado.vue?vue&type=script&lang=js&"
export * from "./loader-invitado.vue?vue&type=script&lang=js&"
import style0 from "./loader-invitado.vue?vue&type=style&index=0&id=c9f2e93a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f2e93a",
  null
  
)

export default component.exports